import { StudentAttendanceCalendarQuery } from "../../../../../../../Utilities";
import { AttendanceStatusFormat } from "../../../../../../Format";
import { AttendanceStatusUtilities } from "../../../../../../Utilities";
import * as StudentNoteComponents from "../../../../../StudentNote";

export function attendanceRecordToCalendarEvent(
	record: StudentAttendanceCalendarQuery["schoolAttendanceRecordConnection"]["edges"][0]["node"],
) {
	return {
		id: record.id,
		name: AttendanceStatusFormat.name(record.attendanceStatus) + (record.notes !== "" ? "*" : ""),
		description: record.notes,
		isAllDay: false,
		startTime: record.arrivalTime,
		endTime: record.departureTime,
		startDate: null,
		endDate: null,
		groups: [
			{
				id: record.attendanceStatus.id,
				name: "Attendance",
				color: AttendanceStatusUtilities.color(record.attendanceStatus),
			},
		],
		isPublic: false,
		_additional: record,
	};
}

export function attendanceNoteToCalendarEvent(
	note: StudentAttendanceCalendarQuery["studentNoteConnection"]["edges"][0]["node"],
) {
	return {
		id: note.id,
		name: note.body,
		description: "",
		isAllDay: true,
		startTime: null,
		endTime: null,
		startDate: note.studentAttendanceNote!.startDate,
		endDate: note.studentAttendanceNote!.endDate,
		isPublic: false,
		groups: [{ id: "notes", name: "Attendance Notes", color: StudentNoteComponents.studentNoteTypeColors.attendance }],
		_additional: note,
	};
}
